module.exports = __webpack_public_path__ + "img/VP-Profi13-Info.94ff2d78.jpg";